import { useEffect, useState } from "react";
import useIsMobile from "../../hooks/useIsMobile";

const COMPACT_PICKER_MEDIA = "(max-width: 1200px)";

export const useReceptionistMobilePickerProps = () => {
  const isMobile = useIsMobile();
  const [isCompact, setIsCompact] = useState(() => {
    if (typeof window === "undefined") return false;
    return window.matchMedia(COMPACT_PICKER_MEDIA).matches;
  });

  useEffect(() => {
    const mq = window.matchMedia(COMPACT_PICKER_MEDIA);
    const onChange = () => setIsCompact(mq.matches);
    onChange();
    mq.addEventListener("change", onChange);
    return () => mq.removeEventListener("change", onChange);
  }, []);

  if (!isCompact) return {};

  return {
    getPopupContainer: () => document.body,
    placement: "bottomLeft",
    popupClassName: "curengo-mobile-picker",
    popupStyle: {
      maxWidth: isMobile ? "calc(100vw - 16px)" : "min(360px, calc(100vw - 24px))",
    },
  };
};

export default useReceptionistMobilePickerProps;
